//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MultiRangeSlider from 'multi-range-slider-vue'
import wcs from '@/scripts/libs/wcs'
import { WcsUser } from '@/scripts/libs/wcs/user'
import RbFacet from './rb-facet.vue'
import { MOBILE, TABLET } from '@/scripts/constants/media-query'
import { ALGOLIA_FACETS } from '@/scripts/constants/algolia'
import { WcsLocales } from '@/scripts/libs/wcs/types/locales'
const { currencySymbol } = wcs.getStoreConfig()
export default {
  name: 'rb-range-facet',
  components: {
    MultiRangeSlider,
  },
  extends: RbFacet,
  props: {
    minPriceRange: {
      type: Number,
      required: true,
    },
    maxPriceRange: {
      type: Number,
      required: true,
    },
    preMin: {
      type: Number,
    },
    preMax: {
      type: Number,
    },
    resetFacetPrice: {
      type: Boolean,
      default: false,
    },
    isInPanel: {
      type: Boolean,
      default: false,
    },
    indexFacet: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      ALGOLIA_FACETS,
      timerId: null,
      timerInput: null,
      currencySymbol,
      minRange: this.preMin || this.minPriceRange,
      maxRange: this.preMax || this.maxPriceRange,
      selectedMin: this.minPriceRange,
      selectedMax: this.maxPriceRange,
      bodyScrollIsEnabled: false,
      timeUpdateValue: 1000,
      timeDebounceInput: 1000,
    }
  },
  computed: {
    isMobile() {
      return this.$mq === MOBILE || this.$mq === TABLET
    },
    typeInput() {
      return this.isMobile ? 'text' : 'number'
    },
    getStep() {
      const { plp } = wcs.getStoreConfig()
      return plp.priceFilter.step || 1
    },
    getMinimumDistance() {
      const { plp } = wcs.getStoreConfig()
      return plp.priceFilter.distance || 30
    },
    formatPrice() {
      const { locale } = wcs.getStoreConfig()
      const reverseFormatCountries = [WcsLocales.JA_JP]
      return reverseFormatCountries.includes(locale)
    },
  },
  watch: {
    preMin(nValue) {
      setTimeout(() => {
        if (nValue !== this.minRange) {
          this.minRange = nValue
          if (this.indexFacet === 0 && this.appliedFacets.length === 1) {
            return
          }
          this.selectedMin = nValue
        }
      }, 100)
    },
    preMax(nValue) {
      setTimeout(() => {
        if (nValue !== this.maxRange) {
          this.maxRange = nValue
          if (this.indexFacet === 0 && this.appliedFacets.length === 1) {
            return
          }
          this.selectedMax = nValue
        }
      }, 100)
    },
    maxPriceRange(nValue) {
      setTimeout(() => {
        this.selectedMax = nValue
      }, 100)
    },
    minPriceRange(nValue) {
      setTimeout(() => {
        this.selectedMin = nValue
      }, 100)
    },
    resetFacetPrice(nValue) {
      if (typeof nValue === 'boolean') {
        if (nValue) {
          this.selectedMin = this.minRange
          this.selectedMax = this.maxRange
        }
      }
    },
  },
  mounted() {
    if (this.isInPanel) {
      const input = document.getElementsByClassName('input-type-range')
      const th = document.getElementsByClassName('thumb') || []
      Array.from(input).forEach((inp) => {
        inp.addEventListener('focusin', this.onEnterClick(this))
      })
      Array.from(th).forEach((value) => {
        value.addEventListener('mouseup', () => {
          this.updateRange({
            minValue: this.selectedMin,
            maxValue: this.selectedMax,
          })
        })
        value.addEventListener('touchend', () => {
          if (this.bodyScrollIsEnabled) {
            this.bodyScrollIsEnabled = false
          }
          this.updateRange({
            minValue: this.selectedMin,
            maxValue: this.selectedMax,
          })
        })
      })
    }
  },
  methods: {
    onEnterClick(vm) {
      return function () {
        document.addEventListener('keydown', (ev) => {
          const allowCode = ['Enter', 'Insert', 'NumpadEnter']
          if (allowCode.includes(ev.code)) {
            if (vm.selectedMin !== vm.minPriceRange || vm.selectedMax !== vm.maxPriceRange) {
              vm.updateRange({
                minValue: vm.selectedMin,
                maxValue: vm.selectedMax,
              })
            }
          }
        })
      }
    },
    debounceValueInput(value, context) {
      const { minValue, maxValue } = value
      const min = Number(minValue)
      const max = Number(maxValue)
      clearTimeout(this.timerInput)
      this.timerInput = setTimeout(() => {
        this.selectedMin = min
        this.selectedMax = max
        if (context === ALGOLIA_FACETS.MIN) {
          if (min === this.minRange) {
            return
          }
          if (min < this.minRange) {
            this.selectedMin = this.minRange + ''
            return
          }
          if (min >= max) {
            this.selectedMin = max - this.getMinimumDistance + ''
          }
        }
        if (context === ALGOLIA_FACETS.MAX) {
          if (max === this.maxRange) {
            return
          }
          if (max > this.maxRange) {
            this.selectedMax = this.maxRange + ''
            return
          }
          if (max <= min) {
            this.selectedMax = min + this.getMinimumDistance + ''
          }
        }
        this.updateRange({
          minValue: this.selectedMin,
          maxValue: this.selectedMax,
        })
      }, this.timeDebounceInput)
    },
    keyDown(e) {
      if (!this.isMobile) {
        return
      }
      const k = e.code || e.key
      const rg = new RegExp(/[0-9]|Digit|Numpad[[0-9]*$/)
      const allowCode = [
        'Backspace',
        'ArrowLeft',
        'ArrowRight',
        'Delete',
        'Backspace',
        'Unidentified',
      ]
      if (!rg.test(k) && !allowCode.includes(k)) {
        e.preventDefault()
      }
    },
    changeValueSlider(e) {
      const { minValue, maxValue } = e
      this.selectedMin = minValue
      this.selectedMax = maxValue
    },
    updateRange(e) {
      clearTimeout(this.timerId)
      this.timerId = setTimeout(() => {
        const { minValue, maxValue } = e
        const isUserEligibleForEarlyAccess = WcsUser.isEarlyAccessActivityInUserClusterCookie()
        const priceRangeFacet = isUserEligibleForEarlyAccess
          ? 'xBestPriceWithEarlyAccess'
          : 'xBestPrice'
        const facet = `${priceRangeFacet}:[${minValue} TO ${maxValue}]`
        this.toggleFacets([facet])
        this.isFromMouse = false
      }, this.timeUpdateValue)
    },
  },
}
